/////////////////////////////////////////////////////////
// Configurations related to user — Uroborox           //
/////////////////////////////////////////////////////////

// Note: User types are not yet supported in Console hosted config.
//       They are configured here and merged via configHelpers.js.

/**
 * User fields (custom extended data).
 * These are intentionally empty — Uroborox doesn't need extra
 * user profile fields at this stage. Fields can be added later
 * as the product evolves.
 */
export const userFields = [
  {
    key: 'interes',
    scope: 'public',
    schemaType: 'multi-enum',
    enumOptions: [
      { option: 'vender', label: 'Vender tu negocio' },
      { option: 'encontrar-inversores', label: 'Encontrar inversores para tu negocio' },
      { option: 'comprar', label: 'Comprar un negocio' },
      { option: 'invertir', label: 'Invertir en negocios' },
    ],
    showConfig: {
      label: 'Tienes interés en',
      displayInProfile: true,
      /* P8A.3: ocultar opciones no seleccionadas en vez de tacharlas.
         Si el usuario no tiene ninguna opción marcada, la sección entera
         se oculta (hasContent = false en SectionMultiEnum). */
      unselectedOptions: false,
    },
    saveConfig: {
      label: 'Tienes interés en',
      displayInSignUp: true,
      isRequired: true,
      requiredMessage: 'Selecciona al menos una opción.',
    },
    userTypeConfig: {
      limitToUserTypeIds: false,
    },
  },
];

// Uroborox user types are managed in Sharetribe Console.
// Do NOT duplicate them here — it causes duplicate entries in the signup form.
export const userTypes = [];
